/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { RoleMapping } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface RoleMappingServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Creates new role mapping
     * This endpoint is used to create a new role mapping
     * @param roleMapping Role mapping to be created
     */
    createRoleMapping(roleMapping: RoleMapping, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete the role mapping
     * Delete the role mapping specified id
     * @param roleMappingId The id of the role mapping to delete.
     */
    deleteRoleMapping(roleMappingId: number, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get all role mappings
     * Returns the list of all role mappings
     */
    getMappedRoles(extraHttpRequestParams?: any): Observable<Array<RoleMapping>>;

    /**
     * Get role mapping by ID
     * Returns the role mapping.
     * @param roleMappingId The id of the role mapping to fetch.
     */
    getRoleMappingById(roleMappingId: number, extraHttpRequestParams?: any): Observable<RoleMapping>;

    /**
     * Update role mapping
     * Update the role mapping with the specified id
     * @param roleMappingId The id of the role mapping to update.
     * @param roleMapping The updated role mapping
     */
    updateRoleMapping(roleMappingId: number, roleMapping: RoleMapping, extraHttpRequestParams?: any): Observable<{}>;

}
